module.exports = {"id":"dp4_3l1q2","text":"Supporting Wellbeing","instructions":"Digital platforms often include features designed to keep users engaged for longer periods.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.3","questionType":"PickOne","random":false,"options":[{"id":"dp4_3l1q2-a1","text":"True","score":1.8},{"id":"dp4_3l1q2-a2","text":"Not sure","score":0},{"id":"dp4_3l1q2-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.3/l1q2.json
// module id = 1245
// module chunks = 41